import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  settingsLocationsCurrentWrapper: {
    flexDirection: 'row',
    marginBottom: Theme.px(70),
  },
  settingsLocationsWrapper: {
    paddingTop: Theme.px(311),
  },
});
